<div class="ui-g ui-fluid">
    <div class="ui-g-12">
        <!-- Left Side -->
        <div class="card card-w-title">

            <div class="ui-g form-group">

                <div class="ui-g-12 ui-md-2">
                    <label><b>Status:</b></label>
                    <p-dropdown id="statusList" name="statusList" [options]="statusList" [disabled]="this.posting"
                        [(ngModel)]="is_active_status" optionLabel="name" optionValue="value">
                    </p-dropdown>
                </div>

                <div class="ui-g-12 ui-md-2">
                    <label><b>Country:</b></label>
                    <p-dropdown class="notranslate" id="dropdown" [options]="countriesList" [disabled]="this.posting"
                        [(ngModel)]="selectedCountry" optionLabel="country_name" optionValue="id">
                    </p-dropdown>
                </div>

                <div class="ui-g-12 ui-md-2" style="padding-top: 30px;">
                    <p-checkbox [(ngModel)]="disabledDates" [value]="disabledDates" [disabled]="this.posting"
                        [binary]=true></p-checkbox>
                    <label style="padding-left:3px;font-style:bold">Disable Dates?</label>
                </div>

                <div class="ui-g-12 ui-md-2">
                    <label><b>From:</b></label>
                    <p-calendar class="notranslate" [showIcon]="true" [disabled]="this.disabledDates || this.posting" showTime="true"
                        hourFormat="12" placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy" [monthNavigator]="true"
                        [yearNavigator]="true" yearRange="1900:2099" [(ngModel)]="query.from_date"></p-calendar>
                </div>

                <div class="ui-g-12 ui-md-2">
                    <label><b>To:</b></label>
                    <p-calendar [showIcon]="true" class="notranslate" showTime="true" hourFormat="12"
                        [disabled]="this.disabledDates || this.posting" placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy"
                        [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2099"
                        [(ngModel)]="query.to_date"></p-calendar>
                </div>
                <div>
                    <div class="ui-g-12 ui-md-3">
                        <label><b>Discount Code:</b></label>
                        <input placeholder="Discount Code" type="text" pInputText [(ngModel)]="discountCodeString" />
                    </div>

                    <div class="ui-g-12 ui-md-3">
                        <label><b>Discount percent:</b></label>
                        <input placeholder="Discount %" type="number" pInputText [(ngModel)]="discountPercentNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-3">
                        <button pButton type="submit" label="Search" [disabled]="this.posting"
                            style=" border-radius: 5px; margin-top:35px;margin-left:25px;width:100px;display: inline-block;"
                            (click)="Submit()">
                        </button>
                    </div>
                    <div class="ui-g-12 ui-md-3">
                        <button pButton type="submit" label="Reset" [disabled]="this.posting"
                            style=" border-radius: 5px; margin-top:35px;margin-left:25px;width:100px;display: inline-block;"
                            (click)="Reset()">
                        </button>
                    </div>

                </div>

                <div class="ui-g-12 ui-md-4">
                    <p *ngIf="e != null" style="color: red; text-align: center;font-weight: bold;">{{e}}</p>
                </div>


            </div>
        </div>

    </div>
</div>








<div style="text-align-last: right;">
    <p-button type="button" [style]="{'margin':'20px'}" [routerLink]="['/',this.slug,'doctor','Referral']" label="Add" class="p-button-lg"
        icon="pi pi-plus"></p-button>
</div>
<div class="card mt-auto">


    <div class="">
        <p-table #dt1 [value]="discountCodeList" [lazy]="true" (onLazyLoad)="loadDiscountCode($event)" dataKey="id"
            styleClass="p-datatable-customers" [rows]="10" [paginator]="true" [scrollable]="true"
            [showCurrentPageReport]="true" [(first)]="first" [totalRecords]="totalRecords" [loading]="loading1"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="
            ['refferaltype','discountcode','discountamount',
    'discountpercent','expirydate']">
            <ng-template pTemplate="caption">


                <!-- <span class="ml-0">

                <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')" placeholder="Discount Code List" disabled/>
            </span> -->


            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="refferaltype" style="font-weight: bold;">Referral Type <p-sortIcon
                            field="refferaltype">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="discountcode" style="font-weight: bold;">Discount Code <p-sortIcon
                            field="discountcode">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="status" style="font-weight: bold;">Status<p-sortIcon field="status">
                        </p-sortIcon>
                    </th>
                    <!-- <th pSortableColumn="status" style="font-weight: bold;">Discount Amount <p-sortIcon field="discountamount">
                        </p-sortIcon>
                    </th> -->
                    <th pSortableColumn="discountpercent" style="font-weight: bold;">Discount Percent <p-sortIcon
                            field="discountpercent">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="maxlimit" style="font-weight: bold;">Used /MaxLimit <p-sortIcon
                            field="maxlimit">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="expirydate" style="font-weight: bold;">Start Datetime <p-sortIcon
                            field="expirydate">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="expirydate" style="font-weight: bold;">Expiry Datetime <p-sortIcon
                            field="expirydate">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="country" style="font-weight: bold;">Country<p-sortIcon field="country">
                        </p-sortIcon>
                    </th>

                    <th pSortableColumn="Update" style="font-weight: bold;">Update<p-sortIcon field="Update">
                        </p-sortIcon>
                    </th>
                </tr>



            </ng-template>

            <ng-template pTemplate="body" let-discountCode>
                <tr>
                    <td>{{discountCode.egd_referral_master_type.referral_type}}</td>
                    <td>{{discountCode.discount_code}}</td>
                    <td>{{discountCode.is_active ? 'Active' : 'Deactive'}}</td>
                    <td>{{discountCode.discount_percent}}%</td>
                    <td>{{discountCode.current_count+" / "+discountCode.max_limit}}</td>
                    <td>{{discountCode.starts_at | date: 'd/M/yyyy, h:mm a'}}</td>
                    <td>{{discountCode.expires_at | date: 'd/M/yyyy, h:mm a'}}</td>
                    <td>{{discountCode?.country !=null ? discountCode?.country?.country_name : 'Global' }}</td>

                    <td><button pButton type="button" icon="pi pi-info-circle"
                            (click)="showDialog(discountCode)"></button></td>

                </tr>
            </ng-template>





            <ng-template pTemplate="paginatorleft">
            </ng-template>
            <ng-template pTemplate="paginatorright">
            </ng-template>
        </p-table>

    </div>

    <p-dialog [(visible)]="display" header="Update Discount Code" [style]="{width: '30vw'}" [resizable]=true
        [contentStyle]="{'height': '350px' ,'overflow':'visible'}">


        <div style="margin-bottom: 10px;">
            <label style="margin-right: 105px;font-weight: bold;">Status</label>
            <p-toggleButton id="status" [(ngModel)]="is_active" [style]="{'width':'50%','border-radius':'50rem'}"
                onLabel="Active" offLabel="Deactive" [onIcon]="'pi pi-check'" offIcon="pi pi-times"></p-toggleButton>
        </div>
        <div style="margin-bottom: 15px;">
            <label style="margin-right: 38px;font-weight: bold;">Start datetime</label>
            <p-calendar id="stDate" class="notranslate" [(ngModel)]="stDate" name="stDate" [style]="{'width':'50%'}"
                [inputStyle]="{'width':'100%','border-radius':'50rem'}" placeholder="Expiry Date (MM/DD/YYYY)"
                dateFormat="dd/mm/yy" showTime="true" hourFormat="12" [monthNavigator]="true" [yearNavigator]="true"
                yearRange="1900:2099" [showIcon]="false" placeholder="dd/mm/yyyy">
            </p-calendar>
        </div>
        <div style="margin-bottom: 30px;">
            <label style="margin-right: 30px;font-weight: bold;">Expiry datetime</label>
            <p-calendar id="expDate" class="notranslate" [(ngModel)]="expDate" name="expDate" [style]="{'width':'50%'}"
                [inputStyle]="{'width':'100%','border-radius':'50rem'}" placeholder="Expiry Date (MM/DD/YYYY)"
                dateFormat="dd/mm/yy" showTime="true" hourFormat="12" [monthNavigator]="true" [yearNavigator]="true"
                yearRange="1900:2099" [showIcon]="false" placeholder="dd/mm/yyyy">
            </p-calendar>
        </div>
        <div style="margin-top: 50px;">
            <label style="margin-right: 50px;font-weight: bold;">Update</label>
            <button (click)="updateDiscountCode()" style="width: 50%;"
                class="btn-sm btn-primary font-weight-bold text-white rounded-pill ml-5 pl-5 pr-5 ">
                Save
            </button>
        </div>
        <div style="margin-top: 20px;">
            <i *ngIf="loading" class="pi pi-spin pi-spinner" style="text-align: center;"></i>
            <p *ngIf="ue != null" style="color: red; text-align: center;font-weight: bold;">{{ue}}</p>
        </div>


    </p-dialog>


</div>
